import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import { Address } from "../interfaces/entities/Cancelamento/PassoCartaCancelamento/Address";
import { Historico } from "../interfaces/entities/Historico";
import { EnderPostal } from "../interfaces/entities/MeuCadastro/EnderPostal";
import { MeuCadastroResponse } from "../interfaces/entities/MeuCadastro/MeuCadastroResponse";
import { UpdateEnderRequest } from "../interfaces/entities/MeuCadastro/UpdateEnderRequest";
import { HttpResponse } from "../interfaces/services/HttpResponse";
import { Response } from "../interfaces/services/Response";
import { getIcon } from "../utils/Icons";

export const getCarteirinha = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/Beneficiario/GetCarteirinha', { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};
export const getMeuPlanoSaude = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/Beneficiario/GetMeuPlanoSaude', { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getTokenUnimed = async (idUsrCont: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/Beneficiario/GetTokenUnimed?idUsrCont=${idUsrCont}&token=0`,
      {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` }
      }
    );
    return response;

  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getPeriodoExtratoUtilizacao = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/Beneficiario/GetPeriodoExtratoUtilizacao', { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getExtratoUtilizacao = async (periodo: string): Promise<Response | null> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get(`/beneficiario/getextratoutilizacao?periodo=${periodo}`, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
      resolve(response);
    } catch (error: any) {
      reject(error.response);
    }
  })

};

export const getHistorico = async (): Promise<Historico> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get('/Beneficiario/GetHistorico', { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });

      const filtroTipo = response.data.filtroTipoEvento.map((f: any) => ({
        id: f.codigo,
        descricao: f.descricao
      }));

      const eventos = response.data.eventos
        .map((evento: any) => ({
          id: evento.id,
          codigo: evento.codigo,
          icon: getIcon(evento.renderIcon),
          bgColor: evento.renderBackcolor,
          dataFormatada: evento.dataFormatada,
          nomePrestador: evento.nomePessoaPrestador,
          idLocalPrestador: `${evento.idLocalPrestador}`,
          descricao: evento.descricao,
          especialidade: evento.descricaoEspecialidade,
          showAgendar: evento.renderShowAgendar,
          showContato: evento.renderShowContato,
        }));

      resolve({
        eventos,
        filtroTipo,
        filtroDataMaxima: response.data.filtroDataMaxima,
        filtroDataMinima: response.data.filtroDataMinima
      })

    } catch (e) {
      reject(e);
    }
  });
}

export const getEmailNFE = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/Beneficiario/GetEmailNFE', { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const atualizarEmailNFE = async (email: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Beneficiario/AtualizarEmailNFE', {
      email: email
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getMeuCadastro = async (): Promise<HttpResponse<MeuCadastroResponse> | null> => {
  try {
    const response = await apiClientes.get('/Beneficiario/GetMeuCadastro', {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error;
  }
};

export const atualizarComunicacao = async (cel: string, tel: string, email: string): Promise<HttpResponse<string> | null> => {
  try {
    const response = await apiClientes.post('/Beneficiario/AtualizarComunicacao', {
      cel,
      tel,
      email
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error;
  }
};

export const getLogradrouroPorCep = async (cep: string): Promise<HttpResponse<EnderPostal[]> | null> => {
  try {
    const response = await apiClientes.get(`/Beneficiario/GetLogradouroPorCep?cep=${cep}`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error;
  }
};

export const atualizarEnderPostal = async (endereco: UpdateEnderRequest): Promise<HttpResponse<string> | null> => {
  try {
    const response = await apiClientes.post('/Beneficiario/AtualizarEnderPostal', {
      cep: endereco.cep.replace('-', ''),
      logradouro: endereco.logradouro,
      bairro: endereco.bairro,
      numero: endereco.numero,
      complemento: endereco.complemento
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error;
  }
};


export const atualizarEnderPostalPagador = async (endereco: UpdateEnderRequest): Promise<HttpResponse<string> | null> => {
  try {
    const response = await apiClientes.post('/Beneficiario/AtualizarEnderPostalPagador', {
      cep: endereco.cep.replace('-', ''),
      logradouro: endereco.logradouro,
      bairro: endereco.bairro,
      numero: endereco.numero,
      complemento: endereco.complemento,
      dtInicValidade: endereco.dtInicValidade
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error;
  }
};

export const cadastrarEmail = async (email: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Beneficiario/CadastrarEmail', {
      email
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error;
  }
};

export const cadastrarEnderecoPostal = async (endereco: Address): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Beneficiario/CadastrarEnderecoPostal', {
      cep: endereco.cep.replace('-', ''),
      logradouro: endereco.logradouro,
      complemento: endereco.complemento,
      bairro: endereco.bairro,
      numero: endereco.numero
    }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error;
  }
};